export default __webpack_public_path__ + "static/media/IconDesc_CoffeeCup.256.b6af06f4.png";